/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * AI token usage record for tracking AI API consumption
 * @export
 * @interface AiTokenUsage
 */
export interface AiTokenUsage {
    /**
     * 
     * @type {number}
     * @memberof AiTokenUsage
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof AiTokenUsage
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof AiTokenUsage
     */
    source: AiTokenUsageSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof AiTokenUsage
     */
    tokensUsed: number;
    /**
     * 
     * @type {Date}
     * @memberof AiTokenUsage
     */
    recordedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof AiTokenUsage
     */
    relatedId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AiTokenUsage
     */
    relatedType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AiTokenUsage
     */
    readonly createdAt: Date;
}


/**
 * @export
 */
export const AiTokenUsageSourceEnum = {
    DocParse: 'doc_parse',
    Compare: 'compare',
    Supplement: 'supplement',
    Other: 'other'
} as const;
export type AiTokenUsageSourceEnum = typeof AiTokenUsageSourceEnum[keyof typeof AiTokenUsageSourceEnum];


/**
 * Check if a given object implements the AiTokenUsage interface.
 */
export function instanceOfAiTokenUsage(value: object): value is AiTokenUsage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('tokensUsed' in value) || value['tokensUsed'] === undefined) return false;
    if (!('recordedAt' in value) || value['recordedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function AiTokenUsageFromJSON(json: any): AiTokenUsage {
    return AiTokenUsageFromJSONTyped(json, false);
}

export function AiTokenUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiTokenUsage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'source': json['source'],
        'tokensUsed': json['tokensUsed'],
        'recordedAt': (new Date(json['recordedAt'])),
        'relatedId': json['relatedId'] == null ? undefined : json['relatedId'],
        'relatedType': json['relatedType'] == null ? undefined : json['relatedType'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function AiTokenUsageToJSON(json: any): AiTokenUsage {
    return AiTokenUsageToJSONTyped(json, false);
}

export function AiTokenUsageToJSONTyped(value?: Omit<AiTokenUsage, 'id'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'source': value['source'],
        'tokensUsed': value['tokensUsed'],
        'recordedAt': ((value['recordedAt']).toISOString()),
        'relatedId': value['relatedId'],
        'relatedType': value['relatedType'],
    };
}

